import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App';
import { SENTRY_DSN } from './config/env';
import './globals.css';

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: `claudafinil@${__APP_VERSION__}`,
    sendDefaultPii: false,
    beforeSend(event) {
      if (!event.breadcrumbs) {
        return event;
      }

      event.breadcrumbs = event.breadcrumbs.map((breadcrumb) => {
        if (
          breadcrumb.category === 'console' &&
          typeof breadcrumb.message === 'string'
        ) {
          return {
            ...breadcrumb,
            message: breadcrumb.message.slice(0, 200),
          };
        }
        return breadcrumb;
      });

      return event;
    },
  });

  Sentry.setTag('context', 'remote-ui');
}

function ErrorFallback(): JSX.Element {
  return (
    <div className="flex h-full min-h-full flex-col items-center justify-center gap-3 bg-background p-6 text-center">
      <p className="m-0 text-sm font-semibold text-foreground">
        Something went wrong
      </p>
      <button
        className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-colors hover:opacity-90"
        onClick={() => window.location.reload()}
        type="button"
      >
        Reload
      </button>
    </div>
  );
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Failed to find root element');
}

createRoot(root).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <App isExtensionRoute={window.location.pathname === '/extension'} />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
